import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { clearField } from '@shared/utils/form-field.utils';
import { getError } from '@shared/utils/error.utils';
import { PhoneNumberTableFilter } from '@shared/components/table-filter-menu/table-filter-menu.models';
import { SmartFormContainer } from '@shared/classes/smart-form-container';

@Component({
  selector: 'app-phone-number-filter',
  templateUrl: './phone-number-filter.component.html',
  styleUrls: ['./phone-number-filter.component.scss'],
})
export class PhoneNumberFilterComponent extends SmartFormContainer {
  readonly getError = getError;
  readonly clearField = clearField;

  @Input() config: PhoneNumberTableFilter;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }
}
